import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a298da94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader-container" }
const _hoisted_2 = {
  class: "loader",
  viewBox: "0 0 20 20"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "bg",
  cx: "10",
  cy: "10",
  r: "8"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "loading-overlay"
}

interface Emits {
  (e: "abort"): void;
}

interface Props {
  overlay?: boolean;
  progress?: number;
  cancellable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    overlay: { type: Boolean, default: false },
    progress: { default: 0 },
    cancellable: { type: Boolean, default: false }
  },
  emits: ["abort"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const computeProgress = (radius: number) => {
  const circumference = Math.ceil(2 * Math.PI * radius);
  return circumference - (props.progress * circumference) / 100;
};
const handleAbortUpload = () => {
  emit("abort");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("circle", {
        class: "progress",
        cx: "10",
        cy: "10",
        r: "8",
        style: _normalizeStyle({
          strokeDashoffset: computeProgress(8),
        })
      }, null, 4)
    ])),
    (props.cancellable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleAbortUpload
        }, " ✖ "))
      : _createCommentVNode("", true),
    (_ctx.overlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})